import { StyledSelect } from '@components/utils/fields/singleSelectField';
import { HStack } from '@lib/uikit';
import capitalize from '@utils/string/capitalize';

import { Select } from './hooks/useVariantSelects';
import { OptionLabel } from './OptionLabel';

export const VariantDropdownSelect = ({
    select,
    onSelectOption,
}: {
    select: Select;
    onSelectOption: (optionName: string, value: string) => void;
}) => {
    return (
        <HStack>
            <OptionLabel>{capitalize(select.name)}</OptionLabel>
            <StyledSelect
                name={select.name}
                value={select.value}
                onChange={(e) => onSelectOption(select.name, e.target.value)}
                disabled={select.options.length === 0}
            >
                <option value={undefined}></option>
                {select.options.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                        selected={select.value === option.value}
                    >
                        {capitalize(option.value)}
                    </option>
                ))}
            </StyledSelect>
        </HStack>
    );
};
